import Vue from 'vue';
import { Token } from './Types';

function buildTokenMixin<T extends Token>() {
    return Vue.extend({
        props: {
            token: {
                required: true,
                type: Object as () => T
            }
        }
    });
}

export default buildTokenMixin;
